/* Cart-Drawer-Bruecke: oeffnet den Theme-Drawer nach JEDEM AJAX-Cart-Add,
   egal welches Script ihn ausfuehrt (Bundle-App, eigene Formulare).
   Ohne sie erfaehrt der Drawer von fremden Adds nichts und der Kunde landet
   auf der Warenkorb-Seite. Belauscht dafuer fetch UND XMLHttpRequest, weil
   App-Scripts mal das eine, mal das andere benutzen. */
(function () {
  'use strict';

  var pending = null;

  function refreshAndOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        // Dieses Theme traegt den Leer-Zustand als Klasse am <cart-drawer>-
        // HOST (cart-drawer.is-empty versteckt die Artikelliste per CSS).
        // renderContents ersetzt nur das Innere und liesse die Klasse vom
        // Seitenaufruf mit leerem Warenkorb stehen — deshalb die Klassen des
        // frisch gerenderten Hosts uebernehmen, bevor neu gerendert wird.
        var fresh = new DOMParser()
          .parseFromString(sections['cart-drawer'], 'text/html')
          .querySelector('cart-drawer');
        if (fresh) drawer.className = fresh.className;
        // renderContents ersetzt #CartDrawer + Header-Bubble, bindet das
        // Overlay neu und ruft open() — exakt der Weg des Theme-eigenen
        // product-form-Elements.
        drawer.renderContents({ id: drawer.productId || null, sections: sections });
      })
      .catch(function () {});
  }

  // Bundle-Apps feuern bei Sets mehrere Adds kurz nacheinander —
  // zusammenfassen, damit der Drawer nur einmal rendert.
  function queue() {
    clearTimeout(pending);
    pending = setTimeout(refreshAndOpen, 150);
  }

  function isCartAdd(url, method) {
    return /\/cart\/add(\.js)?([?#]|$)/.test(String(url || '')) &&
      String(method || 'GET').toUpperCase() === 'POST';
  }

  /* Meta-Pixel: AddToCart aus der /cart/add-Antwort feuern — hier laufen
     ALLE Adds durch (Bundle-App, eigene Formulare), inklusive Menge und
     Preis. Fehlt fbq (Pixel nicht geladen, Consent), passiert nichts. */
  function trackAdd(text) {
    if (typeof window.fbq !== 'function') return;
    try {
      var data = JSON.parse(text);
      var items = data.items || [data];
      var ids = [], value = 0, qty = 0;
      items.forEach(function (it) {
        if (!it) return;
        if (it.product_id) ids.push(String(it.product_id));
        value += it.final_line_price != null ? it.final_line_price : (it.price || 0) * (it.quantity || 1);
        qty += it.quantity || 1;
      });
      if (!qty) return;
      window.fbq('track', 'AddToCart', {
        content_ids: ids,
        content_type: 'product_group',
        value: Math.round(value) / 100,
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
        num_items: qty
      });
    } catch (e) { /* Antwort war kein JSON — dann kein Event */ }
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    var method = (init && init.method) || (input && input.method);
    var result = origFetch.apply(this, arguments);
    if (isCartAdd(url, method)) {
      result.then(function (res) {
        if (res && res.ok) {
          queue();
          res.clone().text().then(trackAdd, function () {});
        }
      }, function () {});
    }
    return result;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._kcbCartAdd = isCartAdd(url, method);
    return origOpen.apply(this, arguments);
  };

  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._kcbCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          queue();
          trackAdd(this.responseText);
        }
      });
    }
    return origSend.apply(this, arguments);
  };

  /* --- Native Formular-Submits auf /cart/add abfangen ---------------------
     Bundle-Apps wie Kaching befuellen das Produktformular (Menge, Bundle-
     Properties) und lassen es KLASSISCH absenden — Shopify leitet dann hart
     zur Warenkorb-Seite weiter, ohne dass je fetch/XHR im Spiel war.
     Hier: denselben Datenstand per AJAX senden und den Drawer oeffnen.
     Bei Fehlern faellt alles auf den nativen Submit zurueck. */

  function isCartAddAction(form) {
    var action = form.getAttribute('action') || (typeof form.action === 'string' ? form.action : '');
    return /\/cart\/add(\.js)?([?#]|$)/.test(String(action));
  }

  function ajaxAddFromForm(form) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('Status ' + res.status);
      queue();
      return res;
    });
  }

  var origSubmit = HTMLFormElement.prototype.submit;

  // Bubble-Phase auf document: laeuft NACH den Form-Handlern der App —
  // deren Aenderungen an den Inputs sind dann schon drin.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !isCartAddAction(form)) return;
    if (e.defaultPrevented) return;                      // ein anderes Script uebernimmt bereits per AJAX
    if (!document.querySelector('cart-drawer')) return;  // ohne Drawer normal weiterleiten
    e.preventDefault();
    ajaxAddFromForm(form).catch(function () { origSubmit.call(form); });
  });

  // form.submit() feuert kein submit-Event — den programmatischen Weg
  // (den Apps gern nehmen) separat abfangen.
  HTMLFormElement.prototype.submit = function () {
    if (isCartAddAction(this) && document.querySelector('cart-drawer')) {
      var form = this;
      ajaxAddFromForm(form).catch(function () { origSubmit.call(form); });
      return;
    }
    return origSubmit.apply(this, arguments);
  };
})();
